import React, { useState } from 'react'
import { bankQuestionService } from '../../services/bankQuestionService_moi'
import toast from 'react-hot-toast'

const TestBankService: React.FC = () => {
  const [lop, setLop] = useState('11')
  const [chuong, setChuong] = useState('1')
  const [bai, setBai] = useState('1')
  const [result, setResult] = useState<string>('')
  const [loading, setLoading] = useState(false)

  const testBankStructure = async () => {
    setLoading(true)
    setResult('🔍 Testing bank structure...')
    
    try {
      await bankQuestionService.debugBankStructure(lop, chuong, bai)
      setResult('✅ Debug completed. Check console for details.')
    } catch (error) {
      setResult(`❌ Error: ${error instanceof Error ? error.message : 'Unknown error'}`)
    } finally {
      setLoading(false)
    }
  }

  const testQuestionCounts = async () => {
    setLoading(true)
    setResult('📊 Counting questions...')
    
    try {
      const counts = await bankQuestionService.getQuestionCounts(lop, chuong, bai)
      setResult(`📊 Question counts:\nTN: ${counts.TN}\nDS: ${counts.DS}\nTL: ${counts.TL}\nTotal: ${counts.TN + counts.DS + counts.TL}`)
    } catch (error) {
      setResult(`❌ Error: ${error instanceof Error ? error.message : 'Unknown error'}`)
    } finally {
      setLoading(false)
    }
  }

  const testRandomQuestions = async () => {
    setLoading(true)
    setResult('🎯 Generating random questions...')
    
    try {
      const quizData = await bankQuestionService.getRandomQuestions(lop, chuong, bai, {
        thoiGianLamBai: 30,
        diemDat: 70,

      })
      setResult(`✅ Quiz generated!\nID: ${quizData.id}\nQuestions: ${quizData.cauHoi.length}\nTime: ${quizData.gioi_han_thoi_gian / 60} min`)
    } catch (error) {
      setResult(`❌ Error: ${error instanceof Error ? error.message : 'Unknown error'}`)
    } finally {
      setLoading(false)
    }
  }

  const testFileAccess = async () => {
    setLoading(true)
    setResult('📁 Testing file access...')
    
    try {
      const types = ['TN', 'DS', 'TL']
      let resultText = '📁 File access test:\n\n'
      
      for (const type of types) {
        const path = `/bank/L${lop}/C${chuong}/B${bai.padStart(2, '0')}/${type}/questions.db`
        try {
          const response = await fetch(path, { method: 'HEAD' })
          if (response.ok) {
            const size = response.headers.get('content-length')
            const sizeKB = size ? Math.round(parseInt(size) / 1024) : 'unknown'
            resultText += `✅ ${type}: ${sizeKB} KB\n`
          } else {
            resultText += `❌ ${type}: ${response.status}\n`
          }
        } catch (error) {
          resultText += `❌ ${type}: Error\n`
        }
      }
      
      setResult(resultText)
    } catch (error) {
      setResult(`❌ Error: ${error instanceof Error ? error.message : 'Unknown error'}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-bold mb-4">🧪 Test Bank Service</h2>
      
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium mb-1">Lớp:</label>
          <select 
            value={lop} 
            onChange={(e) => setLop(e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="10">Lớp 10</option>
            <option value="11">Lớp 11</option>
            <option value="12">Lớp 12</option>
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Chương:</label>
          <select 
            value={chuong} 
            onChange={(e) => setChuong(e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="1">Chương 1</option>
            <option value="2">Chương 2</option>
            <option value="3">Chương 3</option>
            <option value="4">Chương 4</option>
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium mb-1">Bài:</label>
          <select 
            value={bai} 
            onChange={(e) => setBai(e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="1">Bài 1</option>
            <option value="2">Bài 2</option>
            <option value="3">Bài 3</option>
            <option value="4">Bài 4</option>
          </select>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4 mb-4">
        <button
          onClick={testFileAccess}
          disabled={loading}
          className="btn-primary p-2 rounded disabled:bg-gray-400"
        >
          📁 Test File Access
        </button>
        
        <button
          onClick={testBankStructure}
          disabled={loading}
          className="btn-secondary p-2 rounded disabled:bg-gray-400"
        >
          🐛 Debug Bank Structure
        </button>
        
        <button
          onClick={testQuestionCounts}
          disabled={loading}
          className="btn-soft p-2 rounded disabled:bg-gray-400"
        >
          📊 Count Questions
        </button>
        
        <button
          onClick={testRandomQuestions}
          disabled={loading}
          className="btn-primary p-2 rounded disabled:bg-gray-400"
        >
          🎯 Generate Quiz
        </button>
      </div>
      
      {result && (
        <div className="mt-4 p-4 bg-gray-100 rounded">
          <h3 className="font-semibold mb-2">Result:</h3>
          <pre className="text-sm whitespace-pre-wrap">{result}</pre>
        </div>
      )}
      
      {loading && (
        <div className="mt-4 p-4 bg-yellow-100 rounded text-center">
          ⏳ Loading...
        </div>
      )}
    </div>
  )
}

export default TestBankService
